import React from 'react'
import styles from './styles.scss'

const Loader = ({className}) => (
  <div className={className}>
    {/*<div className={styles.Logo}/>*/}
    <div className={styles.Loader}/>
  </div>
)

export default Loader



// WEBPACK FOOTER //
// ./src/components/ClientCollection/Loader/index.js